export enum RoleEnum {
  SUPER_USER = "super-user",
  SUPER_ADMIN = "super-admin",
  ADMIN = "admin",
  SALES_MANAGER = "sales-manager",
  SALES = "sales",
  PURCHASE_MANAGER = "purchase-manager",
  PURCHASE = "purchase",
  LOGISTIC_MANAGER = "logistic-manager",
  LOGISTIC = "logistic",
  UPLOAD_MANAGER = "upload-manager",
  UPLOAD = "upload",
  SUPPORT_MANAGER = "support-manager",
  SUPPORT = "support",
}
